import './import-excel-modal.less';

import React from 'react';
import {Button, Icon, message, Modal, Upload} from 'antd';
import {inject, observer} from 'mobx-react';
import {excelToJSON} from '../../../../helpers/parse-excel';
import {mosPropNames} from '../dictionaries/prop-names';
import {stateCar} from '../../../../helpers/api';


@inject("clientsStore")
@observer
export class ImportExcelModal extends React.Component {

  state = {
    loading: false,
    file: null,
    showProgress: false,
    progressCurrent: 0,
    progressTotal: 0,
    progressExists: 0,
    progressFailed: 0,
  };


  render() {
    const { loading, file } = this.state;
    const props = {
      accept: '.xlsx',
      beforeUpload: file => {
        console.log('file', file);
        this.setState({ file: file });
        return false;
      },
      fileList: file && [file],
    };

    return (
      <Modal
        visible={true}
        onCancel={::this.onCancel}
        title="Импорт машин"
        footer={false}
        width={650}>
        <div className="clients-import-excel">
          <div className="form-group">
            <Upload {...props}>
              <Button>
                <Icon type="upload" /> Выберите файл
              </Button>
            </Upload>
          </div>
          <div className="form-submit">
            <Button size={'large'} type="primary" onClick={::this.submit} loading={this.state.loading}>Импортировать</Button>
          </div>

          <Modal
            visible={this.state.showProgress}
            onCancel={() => !this.state.loading && this.setState({ showProgress: false })}
            title="Статус"
            footer={false}>

            {this.state.progressCurrent === this.state.progressTotal && <h2>Завершено</h2>}
            {this.state.progressCurrent !== this.state.progressTotal && <h2>{this.state.progressCurrent} / {this.state.progressTotal}</h2>}

            <div><b>Всего машин</b>: {this.state.progressTotal}</div>
            <div><b>Дубликатов</b>: {this.state.progressExists}</div>
            <div><b>Ошибок данных</b>: {this.state.progressFailed}</div>

          </Modal>
        </div>
      </Modal>
    );
  }

  async submit() {
    this.setState({ loading: true });

    try {
      const excel = await excelToJSON(this.state.file);

      const nameToField = Object.keys(mosPropNames).reduce((prev, key) => {
        if (!key.startsWith('lastPass') && !['cid', 'sendSms'].includes(key)) {
          prev[mosPropNames[key].replace(/\s+/, '').toLowerCase()] = key;
        }
        return prev;
      }, {});
      console.log('nameToField', nameToField)

      if (excel && excel.length > 0) {
        const items = excel[0];

        this.setState({
          showProgress: true,
          progressCurrent: 0,
          progressTotal: items.length,
          progressExists: 0,
          progressFailed: 0,
        });

        let i = 0;
        for (const item of items) {
          this.setState({ progressCurrent: i });
          i++;

          const car = Object.keys(item)
            .reduce((prev, key) => {
              const nameKey = key.replace(/\s+/i, '').toLowerCase();
              return nameToField[nameKey] ? {...prev, [nameToField[nameKey]]: item[key] && item[key].toString()} : prev;
            }, {});


          console.log('car', car)

          const state = await this.getCarState(car);

          if (!state) {
            this.setState({ progressFailed: this.state.progressFailed + 1 });
            continue;
          }
          if (state.exists) {
            this.setState({ progressExists: this.state.progressExists + 1 });
            continue;
          }

          await this.addCar(car);
        }
        this.setState({ progressCurrent: i });
        message.success('Машины успешно импортированны');
      } else {
        message.error('Не найдено данных в этом файле');
      }

      this.setState({ loading: false });
    } catch (e) {
      console.error(e);
      message.error(`Ошибка при загрузке данных: ${e && e.stack}`);
    }

  }

  onCancel() {
    if (!this.state.loading) {
      this.props.history.goBack();
    }
  }

  getCarState(car) {
    return stateCar(car.number);
  }

  addCar(car) {
    return this.props.clientsStore.add(car.number, car, this.props.page);
  }

}





// WEBPACK FOOTER //
// ./src/components/pages/clients/modals/import-excel-modal.js